// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__QYxRQ","header":"Main_header__2JXDV","title":"Main_title__54CKq"};